import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import {
  AppRoutingModule,
  components as mainComponents,
} from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { MatBadgeModule } from '@angular/material/badge';
import { LoadingInterceptor } from '@core/interceptors/loading.interceptor';

/**
 * Root feature module.
 */
@NgModule({
  declarations: [AppComponent, mainComponents],
  imports: [
    BrowserAnimationsModule,
    CoreModule,
    HttpClientModule,
    SharedModule.forRoot(),
    // AppRoutingModule must be loaded last.
    AppRoutingModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
